import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoFile } from "@/shared/model/edo-file.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { deleteEntity } from "../../../../shared/reducers/entities/edo-file.reducer";

interface IDeleteFileProps {
  file: IEdoFile;
  open: boolean;
  onClose: () => void;
}

const DeleteFile = (props: IDeleteFileProps) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector<EntityState<IEdoFile>>(
    (state) => state.edoFile
  );

  const { open, onClose: handleClose, file } = props;

  const confirmDelete = () => {
    dispatch(deleteEntity(file.id));
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate
            contentKey="edocendoApp.edoFile.delete.question"
            interpolate={{ nome: file?.originalFileName }}
          />
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteFile;
